import React from 'react';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import InputField from '../InputField';

import './style.less';

export default class MultipleField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onNew: PropTypes.func.isRequired,
    onClear: PropTypes.func,
    onChange: PropTypes.func, // callback for entire component change
    component: PropTypes.func.isRequired,
    clearable: PropTypes.bool,
    className: PropTypes.string,
    inputs: PropTypes.arrayOf(PropTypes.object)
  };

  static defaultProps = {
    clearable: true
  };

  onChange(index, ...rest) {
    this.props.onChange(index, ...rest);
  }

  onClear(index, key, value) {
    if (this.props.clearable && this.props.onClear) {
      this.props.onClear(index, key, value);
    }
  }

  render() {
    let newInput = this.props.onNew();
    let inputs = this.props.inputs || [];
    inputs = inputs.concat(newInput);

    let inputViews = inputs.map((input, index) => {
      let component = (this.props.component || InputField);
      let customComponent = React.createElement(component, {
          'name': input.key,
          'className': this.props.className,
          'value': input.value,
          'onInput': this.onChange.bind(this, index)
        }
      );

      let clearableView = null;
      if (this.props.clearable) {
        clearableView = (
          <div className="close-icon"
               onClick={this.onClear.bind(this, index, input.key, input.value)}>
            <FontAwesome name="close"/>
          </div>);
      }

      return (
        <div key={input.key} className="multiple-input-field">
          {customComponent}
          {clearableView}
        </div>
      );
    });

    return (
      <div className="multiple-input-field-group">
        {inputViews}
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/FieldComponents/MultipleField/index.jsx
 **/